module.exports = __webpack_public_path__ + "d45092f5662a4bfaa1eec94109ec464b.svg";